var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2505 4.66667V13.8333C18.2505 15.8583 16.6087 17.5 14.5838 17.5H5.41716C3.39224 17.5 1.75049 15.8583 1.75049 13.8333V4.66667C1.75049 2.64175 3.39224 1 5.41716 1H14.5838C16.6087 1 18.2505 2.64175 18.2505 4.66667Z",
    stroke: "#4C2D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2505 9.24984H13.9504C13.7772 9.24984 13.6177 9.34793 13.5407 9.50284L12.2436 12.0961C12.0749 12.4343 11.5927 12.4343 11.4241 12.0961L8.56132 6.37243C8.3954 6.04059 7.92424 6.03326 7.74824 6.35959L6.31916 9.00876C6.23849 9.15726 6.08357 9.24984 5.91582 9.24984H1.75049",
    stroke: "#4C2D6A",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHeaderIcon);
export default __webpack_public_path__ + "static/media/dashboard-header-icon.3c15e9bf9fa9ac467b27404f4348eb2a.svg";
export { ForwardRef as ReactComponent };